// http://www.ilab-x.com/wiki/v2#6
import axios from "axios";
import md5 from "js-md5";
import stepInfo from "./StepInfo";
import { Message } from "element-ui";

export default class ILab {
  constructor(appid, secret, originId) {
    this.fromILab = false;
    this.appid = 106628;
    // this.appid = 100400;
    this.secret = "26VEP7vEEqdvYzSEvfb8HylOQRT7EzTIvfKaDwT7VBY=";
    // this.secret = "SbYymvfZ8UjEmShxRAB0b1Dtaa0uGjDOOJa/f0Mbuo4=";
    this.ticket = this.getHrefParams("ticket");
    this.signature = "";
    this.accessToken = ""; // token
    this.username = "test3"; // 实验空间用户账号
    this.startTime = ""; // 实验开始时间
    this.endTime = ""; // 实验结束时间
    this.timeUsed = ""; // 实验用时
    this.originId = "";

    this.steps = {}; // 实验步骤记录
    this.stepMap = {}; // 用于shi
    this.GetSessionStorage(); // 初始化 无法判断是是刷新还是第一次进入， 防止初始化清空数据
    if (!this.ticket) {
      this.fromILab = false;
      return;
    }

    this.init();
  }
  // 初始化
  init() {
    this.signature = this.encryption();
    this.fromILab = true;
    this.startTime = this.startTime ? this.startTime : new Date().getTime();
    this.originId =
      this.startTime + "_" + Math.ceil(Math.random() * 1000) + this.signature.substring(0, 5); // 时间戳 + 随机数

    this.SetSessionStorage();
    // this.GetUserInfo(this.appid, this.signature, this.ticket)
  }

  // 存储进入sessionStorage
  SetSessionStorage() {
    let obj = {
      fromILab: this.fromILab,
      appid: this.appid,
      secret: this.secret,
      ticket: this.ticket,
      signature: this.signature,
      accessToken: this.accessToken,
      username: this.username,
      startTime: this.startTime,
      originId: this.originId,
      steps: this.steps,
      stepMap: this.stepMap
    };
    sessionStorage.setItem("iLabObj", JSON.stringify(obj));
  }
  // 获取SessionStroage的值
  GetSessionStorage() {
    // 如果 fromILab 是true 表明内容存在  主要防止刷新导致数据初始化
    if (this.fromILab) return;

    let obj = sessionStorage.getItem("iLabObj");
    if (!obj) return;
    obj = JSON.parse(obj);
    Object.keys(obj).forEach(item => {
      this[item] = obj[item];
    });
  }

  // MD5加密
  encryption() {
    const md5Str = `${decodeURIComponent(this.ticket)}${this.appid}${this.secret}`;
    return md5(md5Str);
  }

  // 获取url地址参数
  getHrefParams(variable) {
    let query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }

  // 计算消耗秒数
  CountSeconds(startTime, endTime) {
    return Math.round((new Date(endTime).getTime() - new Date(startTime).getTime()) / 1000);
  }

  // 步骤埋点调用函数
  /**
   *
   * @param {*} param0
   */
  StartStep(stepName) {
    //   需要判断是否存在，存在则return
    if (this.stepMap[stepName]) return;

    let obj = {
      seq: stepInfo[stepName].seq,
      title: stepInfo[stepName].name,
      startTime: new Date().getTime(),
      endTime: 0, // 结束步骤赋值
      timeUsed: 0, // 结束步骤赋值
      expectTime: 300,
      maxScore: 100,
      score: 100, // 结束步骤赋值
      repeatCount: 10,
      evaluation: "", // 结束步骤赋值
      scoringModel: "" // 结束步骤赋值
    };
    this.stepMap[stepName] = obj;
    this.SetSessionStorage();
  }
  EndStep(stepName, params) {
    // 主要是存储 endTime score
    this.stepMap[stepName].score =
      params.score || params.score === 0 ? params.score : this.stepMap[stepName].score;
    this.stepMap[stepName].endTime = new Date().getTime();
    this.stepMap[stepName].timeUsed = this.CountSeconds(
      this.stepMap[stepName].startTime,
      this.stepMap[stepName].endTime
    );
    this.stepMap[stepName].evaluation = params.evaluation
      ? params.evaluation
      : this.stepMap[stepName].evaluation;
    this.stepMap[stepName].scoringModel = params.scoringModel ? params.scoringModel : "赋分模型";
    this.SetSessionStorage();
  }

  // 回传结果参数
  async DataUploadParams(obj) {
    let params = {
      username: this.username,
      // title: "基于股票多因子策略模型的量化金融虚拟仿真实验教学项目",
      title: "基于高频数据的期货股票量化交易的虚拟仿真实验",
      status: 1,
      score: obj ? obj.score : 0,
      startTime: this.startTime,
      endTime: new Date().getTime(),
      timeUsed: this.CountSeconds(this.startTime, new Date().getTime()),
      appid: this.appid,
      originId: this.originId,
      steps: []
    };

    let includesSeq = [];

    Object.keys(this.stepMap).forEach((item, index) => {
      includesSeq.push(item.seq);
      if (!this.stepMap[item].endTime) {
        this.stepMap[item].endTime = params.endTime - 1;
      }
      if (!this.stepMap[item].scoringModel) {
        this.stepMap[item].scoringModel = "赋分模型";
      }
      if (!this.stepMap[item].evaluation) {
        this.stepMap[item].evaluation = "优";
      }
      if (!this.stepMap[item].timeUsed) {
        this.stepMap[item].timeUsed = this.CountSeconds(
          this.stepMap[item].startTime,
          this.stepMap[item].endTime
        );
      }
      this.stepMap[item].score = Math.round(this.stepMap[item].score);
      params.steps.push(this.stepMap[item]);
    });
    if (Object.keys(this.stepMap).length < 10) {
      Object.values(stepInfo).forEach(item => {
        if (includesSeq.includes(item.seq)) return;
        let obj = {
          seq: item.seq,
          title: item.name,
          startTime: this.startTime,
          endTime: params.endTime - 1,
          timeUsed: this.CountSeconds(this.startTime, new Date().getTime()),
          // timeUsed: 0,
          expectTime: 600,
          maxScore: 100,
          score: 0,
          repeatCount: 1,
          evaluation: "没有实验",
          scoringModel: "赋分模型",
          remarks: "备注"
        };
        params.steps.push(obj);
      });
    }

    let res = await this.DataUpload(this.accessToken, JSON.stringify(params));
    if (res.data.code != 0 && res.data.code != 2) {
      //   Message.error(res.msg);
      Message({
        type: "error",
        message: res.data.msg
      });
      return 1;
    }
    if (res.data.code != 2) {
      Message({
        type: "success",
        message: "上传成功"
      });
      return;
    }
    // access_token 超时  需要重新获取token
    let reRes = await this.DataUpload(this.accessToken, JSON.stringify(params));
    this.accessToken = encodeURIComponent(reRes.data.access_token);
    this.SetSessionStorage();

    if (reRes.code == 0) {
      this.DataUploadParams(obj);
    } else {
      Message({
        type: "error",
        message: res.data.msg
      });
    }
  }
  // 传参数进入

  // 调用实验报告上传接口
  async HandleAttachmentUpload(fileData, name, fileTitle) {
    let fileName = encodeURIComponent(name);
    let title = encodeURI(fileTitle);
    let remarks = encodeURI("无标记");
    // let data = sessionStorage.getItem("file")

    await this.AttachmentUpload(fileName, title, remarks, fileData).then(res => {
      if (res.data.code != 0) {
        Message({
          type: "error",
          message: res.data.msg
        });
        return;
      }
      Message({
        type: "success",
        message: "上传成功"
      });
    });
  }

  /**
   * 接口
   */
  // 获取用户信息和access_token
  GetUserInfo(appid, signature, ticket) {
    if (!this.ticket) return;
    // 向本地发送请求， 通过nginx跳转
    axios
      .get(
        `${process.env.VUE_APP_ILAB}/open/api/v2/token?ticket=${this.ticket}&appid=${this.appid}&signature=${this.signature}`
      )
      .then(res => {
        if (res.data.code != 0) {
            Message({
              type: "error",
              message: res.data.msg
            });
            return;
          }
        this.accessToken = encodeURIComponent(res.data.access_token);
        this.username = res.data.un;
        this.SetSessionStorage();
      });
  }
  // 实验结果数据回传结果
  DataUpload(accessToken, data) {
    return axios.post(
      `${process.env.VUE_APP_ILAB}/open/api/v2/data_upload?access_token=${accessToken}`,
      data
    );
  }
  // 实验报告上传接口
  AttachmentUpload(fileName, title, remarks, data) {
    // return axios.post(
    //   `${process.env.VUE_APP_ILAB}/open/api/v2/attachment_upload?access_token=${this.accessToken}&appid=${this.appid}&originId=${this.originId}&filename=${fileName}&title=${title}&remarks=${remarks}`,
    //   data,{

    //   }
    // );
    // console.log("fileName, title, remarks", fileName, title, remarks);
    // return
    fetch(
      `${process.env.VUE_APP_ILAB}/open/api/v2/attachment_upload?access_token=${this.accessToken}&appid=${this.appid}&originId=${this.originId}&filename=${fileName}&title=${title}&remarks=${remarks}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/pdf"
        },
        body: data
      }
    );
  }
  // 获取实验结果接口
  DataGet(accessToken, appid, signature) {
    return axios.get(
      `${process.env.VUE_APP_ILAB}/open/api/v2/data_get?access_token=${this.accessToken}&appid=${this.appid}&signature=${this.signature}`
    );
  }
  // 重新获取access_token
  Refresh(accessToken, appid, signature) {
    return axios.get(
      `${process.env.VUE_APP_ILAB}/open/api/v2/token/refresh?access_token=${this.accessToken}&appid=${this.appid}&signature=${this.signature}`
    );
  }
}
